import { render, staticRenderFns } from "./CardAlerts.vue?vue&type=template&id=6df7164a&"
import script from "./CardAlerts.vue?vue&type=script&lang=js&"
export * from "./CardAlerts.vue?vue&type=script&lang=js&"
import style0 from "./card_alerts.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports